import { action, makeObservable, observable, runInAction } from 'mobx';
import { webServiceProvider } from 'shared';
import AsyncData from 'stores/abstract/AsyncData';

class TripObject {
  loaded = false;
  type = null;
  id = 0;
  attachments = new AsyncData();

  constructor(jsonObject) {
    const { ...actualObject } = jsonObject;
    Object.assign(this, actualObject);
    this.loaded = true;
    this.id = this.tripId;

    makeObservable(this, {
      attachments: observable,
      loaded: observable,
      type: observable,
      updateType: action,
      getAttachments: action,
    });
  }

  updateType = async (type) => {
    type = type.toLowerCase();
    if (type !== 'personal' && type !== 'business') {
      throw new Error('Invalid type for trip!');
    }
    await webServiceProvider.put(`v1/trip/${this.tripId}`, { type: type });

    runInAction(() => {
      this.type = type;
    });
  };

  getAttachments = async () => {
    try {
      runInAction(() => {
        this.attachments.pending = true;
        this.attachments.loaded = false;
      });

      const { data } = await webServiceProvider.get(
        `v1/trip/${this.id}/attachments`
      );

      runInAction(() => {
        this.attachments = data;
        this.attachments.isError = false;
      });
    } catch (err) {
      runInAction(() => {
        this.attachments.isError = true;
      });
      throw new Error('Error in getting trip file attachments!');
    } finally {
      runInAction(() => {
        this.attachments.pending = false;
        this.attachments.loaded = true;
      });
    }
  };
}

export default TripObject;
